import { IoArrowBackOutline } from 'react-icons/io5';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const GoBackArrow = () => {
  const navigate = useNavigate();
  const onClickGoBackHandler = () => navigate(-1);

  return <IoArrowBackOutline onClick={onClickGoBackHandler} className="h-8 w-8 cursor-pointer text-ph-white-50" />;
};

export default GoBackArrow;
